// Local editorial visuals: no third-party image request while browsing.
export function sportImage(sport: string): string {
  const name = sport.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const images: [RegExp, string][] = [
    [/football(?! americain)/, 'football'],
    [/basket/, 'basketball'],
    [/handball|volley|badminton|squash|padel|tennis de table|roller|skateboard/, 'court'],
    [/hockey|patinage/, 'ice'],
    [/rugby|football americain|golf|equestres|tir a l.arc/, 'field'],
    [/tennis/, 'tennis'],
    [/natation|triathlon/, 'swimming'],
    [/surf|voile|canoe|plongee/, 'ocean'],
    [/cyclisme/, 'cycling'],
    [/yoga|pilates|danse|gymnastique/, 'yoga'],
    [/boxe|judo|karate|aikido|lutte|taekwondo|escrime/, 'combat'],
    [/musculation|crossfit|halterophilie/, 'fitness'],
    [/ski|snowboard|biathlon|randonnee|trail|escalade|parachutisme/, 'mountain'],
  ];
  return `/images/sports/${images.find(([match]) => match.test(name))?.[1] || 'running'}.webp`;
}
